
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSnowShowersPolartwilight as ObiSnowShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-snow-showers-polartwilight.js';
 
 
 

 
 export const ObiSnowShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-snow-showers-polartwilight',
   elementClass: ObiSnowShowersPolartwilightElement,
   events: {
     
   }
  });
 
 